import type { IconNode } from '../types';

/**
 * @name chairs-table-platter
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNlY1IiAvPgogIDxwYXRoIGQ9Ik04IDEwYTQgNCAwIDAgMSA4IDAiIC8+CiAgPHBhdGggZD0iTTYgMTBoMTIiIC8+CiAgPHBhdGggZD0iTTEyIDEwdjkiIC8+CiAgPHBhdGggZD0iTTggMTl2LTRjMC0uNi0uNC0xLTEtMUgyIiAvPgogIDxwYXRoIGQ9Ik0yIDh2MTEiIC8+CiAgPHBhdGggZD0iTTE2IDE5di00YTEgMSAwIDAgMSAxLTFoNSIgLz4KICA8cGF0aCBkPSJNMjIgOHYxMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/chairs-table-platter
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const chairsTablePlatter: IconNode = [
  ['path', { d: 'M12 6V5', key: 'df05cx' }],
  ['path', { d: 'M8 10a4 4 0 0 1 8 0', key: '113s14' }],
  ['path', { d: 'M6 10h12', key: '1hwodj' }],
  ['path', { d: 'M12 10v9', key: 'ocssa' }],
  ['path', { d: 'M8 19v-4c0-.6-.4-1-1-1H2', key: '1wnpi0' }],
  ['path', { d: 'M2 8v11', key: '12olib' }],
  ['path', { d: 'M16 19v-4a1 1 0 0 1 1-1h5', key: '1f5zni' }],
  ['path', { d: 'M22 8v11', key: '1ohgna' }],
];

export default chairsTablePlatter;
